import { api } from '@/services';

export default {
  async fetchDistribuicaoItems({ commit, dispatch }, payload) {
    const params = new URLSearchParams();

    Object.keys(payload).forEach((key) => {
      const value = payload[key];
      if (Array.isArray(value)) {
        params.append(key, value.join(','));
      } else if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach((subKey) => {
          params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
        });
      } else if (value) {
        params.append(key, value);
      }
    });

    dispatch('toggleLoading', true, { root: true });

    const { data } = await api.get('/distribuicao', { params });

    commit('SET_DISTRIBUICAO_TABLE_ITEMS', data.data);
    commit('paginacao/SET_PAGINADOR', data, { root: true });

    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async fetchMarcasInvoice({ commit, dispatch, rootGetters }, payload) {
    const empresaTrustReg = /TRUST\s*-\s*IMPORTACAO\s+E\s+EXPORTACAO/i;
    const empresasSelecionadas = rootGetters['Auth/getEmpresasSelecionadasNomeCNPJ'];

    const isTrustEmpresaSelecionada = empresasSelecionadas.some((empresa) => empresaTrustReg.test(empresa.nome));

    if (!isTrustEmpresaSelecionada) {
      return;
    }

    const params = new URLSearchParams();

    params.append('dataInvoice', payload.dataInvoice);

    dispatch('toggleLoading', true, { root: true });

    const { data } = await api.get('/distribuicao/invoice', { params });

    commit('SET_MARCAS', data);

    dispatch('toggleLoading', false, { root: true });
  },
  async prepararExcel() {
    const { data } = await api.get('/distribuicao/excel');

    if (!data) return null;

    const excelFormatado = data.map((infoDist) => ({
      status: infoDist.status,
      referenciaTrust: infoDist.referenciaTrust,
      marca: infoDist.marca,
      codigoProduto: infoDist.codigoProduto,
      descricaoProduto: infoDist.descricaoProduto,
      estoqueAtual: infoDist.estoqueAtual,
      quantidadeComprada: infoDist.quantidadeComprada,
      etd: infoDist.etd,
      eta: infoDist.eta,
      numeroInvoice: infoDist.numeroInvoice,
      dataInvoice: infoDist.dataInvoice,
      valorInvoice: infoDist.valorInvoice,
      numeroPedidoCompra: infoDist.numeroPedidoCompra,
      previsaoCambio: infoDist.previsaoCambio,
      dataInicioProducao: infoDist.dataInicioProducao,
    }));

    return excelFormatado;
  },
};
